import LocalImageIcon from './LocalImageIcon';

export default LocalImageIcon;
